/*
 * Copyright (c) 2021.
 * Md Naimul Hasan
 * naim886@gmail.com
 * 01719123886
 * www.naimbd.com
 */

import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import loader from "../../../Assets/image/loader/ripple.svg";
import Pagination from "react-js-pagination";
import axios from "axios";
import BASEURL from "../../../Constants";


const CustomerList = () => {
    const [activePage, setActivePage] = useState(1)
    const [itemsCountPerPage, setItemsCountPerPage] = useState(0)
    const [totalItemsCount, setTotalItemsCount] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [users, setUsers] = useState([])
    const getUser = (pageNumber = null) => {
        setIsLoading(true)
        setActivePage(pageNumber)
        axios.get(BASEURL+'/api/dashboard/get-customer-list?page='+pageNumber).then(res=>{
            setUsers(res.data.data)
            setItemsCountPerPage(parseInt(res.data.meta.per_page))
            setTotalItemsCount(res.data.meta.total)
            setActivePage(res.data.meta.current_page)
            setIsLoading(false)
        })

    }
    useEffect(() => {
        getUser()
    }, []);

    return (
        <main>
            <div className="container-fluid px-4">
                <h1 className="mt-4">Customer List</h1>
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item"><Link to={'/'}>Dashboard</Link></li>
                    <li className="breadcrumb-item active">Customer List</li>
                </ol>
                <div className="my-card">
                    <div className="row">
                        <div className="col-md-12">
                            <table className={'table table-hover table-bordered'}>
                                <thead>
                                <tr>
                                    <th>SL</th>
                                    <th>Name</th>
                                    <th>Phone Number</th>
                                    <th>Email</th>
                                    <th>Registration Date</th>
                                </tr>
                                </thead>
                                <tbody>
                                {users.map((user, index)=>(
                                    <tr key={index}>
                                        <td>{index+1}</td>
                                        <td>{user.name}</td>
                                        <td>{user.phone}</td>
                                        <td>{user.email}</td>
                                        <td>{user.created_at}</td>
                                    </tr>
                                ))}
                                </tbody>

                            </table>
                            {Object.keys(users).length == 0 && !isLoading ?
                                <div className="loader">
                                    <h6 className={'text-danger text-center'}>No Data Found</h6>
                                </div> : null
                            }
                            {isLoading ?
                                <div className="loader">
                                    <img src={loader} alt={'Loader'}/>
                                </div> : null
                            }
                            {totalItemsCount > 20 ?
                                <nav aria-label="Page navigation example">
                                    <Pagination
                                        activePage={activePage}
                                        itemsCountPerPage={itemsCountPerPage}
                                        totalItemsCount={totalItemsCount}
                                        // pageRangeDisplayed={5}
                                        onChange={getUser}
                                        nextPageText="Next"
                                        prevPageText="Previous"
                                        firstPageText="First"
                                        lastPageText="Last"
                                        itemClass="page-item"
                                        linkClass="page-link"
                                    />
                                </nav> : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default CustomerList;
